'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['box-sizing:border-box;> *{transform-origin:center center;animation:', ' 0.6s infinite cubic-bezier(0.41,0.01,0.58,1);}'], ['box-sizing:border-box;> *{transform-origin:center center;animation:', ' 0.6s infinite cubic-bezier(0.41,0.01,0.58,1);}']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _rotate = require('./rotate360');

var _rotate2 = _interopRequireDefault(_rotate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Spin = _styledComponents2.default.div(_templateObject, _rotate2.default);

Spin.displayName = 'Spin';

exports.default = Spin;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/Spin/Spin.js
// module id = 514
// module chunks = 4